import styled from 'styled-components'
// themes
import { colors } from 'themes/index'

export const Container = styled.div`
  padding: 20px 30px 40px;
`

export const Header = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  font-size: 18px;

  svg {
    right: 0 !important;
  }
`

export const CompaniesContainer = styled.div`
  margin-top: 30px;
  display: flex;
  flex-direction: column;
  gap: 20px;
`

export const CompanyWrapper = styled.div`
  border-radius: 6px;
  padding: 8px;
  box-shadow: 0 0 3px rgba(0, 0, 0, 0.2);
  cursor: pointer;
  font-size: 20px;
  background: ${colors.purple400};
  color: white;

  > div:last-child {
    font-size: 14px;
  }

  &:hover {
    opacity: 0.8;
  }
`
